<scitis-app-global-page-header [pageTitle]="'Metainformation'">

  <ng-template #entryCount>
    <div class="page-header-counts">
      <div class="count">
        <span class="badge badge-pill badge-primary" [innerText]="metaDataCount"></span>
        <span class="count-label" translate>MetaData</span>
      </div>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="search">
      <input class="form-control" type="search"
             [(ngModel)]="searchTerm"
             (change)="onSearch()"
             [placeholder]=" ('Search metadata' | translate) + '...'">
    </div>
  </ng-template>

  <ng-template #filterElement>
    <button class="btn btn-primary me-2"
            (click)="onAddMetaData()"
            [disabled]="!userIsAllowedToEdit">
      <span class="fa-solid fa-plus"></span>
      <span translate>New MetaData</span>
    </button>
  </ng-template>


</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="pb-2">
      <table class="table table-signals table-hover vertical-align-middle mb-0">
        <thead>
        <tr>
          <th scope="col" class="sortable col-auto ps-2" sortable="key" (sort)="onColumnSort($event)">
            <span translate>Key</span>
          </th>
          <th scope="col" class="sortable" sortable="value" (sort)="onColumnSort($event)">
            <i class="fa-solid fa-pen mr-2" title="This column can be edited inline"></i>
            <span translate>Value</span>
          </th>
          <th scope="col" class="sortable" sortable="updateBy" (sort)="onColumnSort($event)">
            <span translate>Update By</span>
          </th>

          <th scope="col" class="sortable" sortable="updateTime" (sort)="onColumnSort($event)">
            <span translate>Update Time</span>
          </th>
          <th class="text-right" scope="col">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>
          @for (metaDataItem of metaDataArray| paginate: paginateSettings; track $index) {
            <tr>
              <td class="ps-2">
                <ngb-highlight
                    [result]="metaDataItem.key"
                    [title]="metaDataItem.key"
                    class="font-weight-bold truncate truncate-lg"
                    [term]="searchTerm">
                </ngb-highlight>
              </td>
              <td>
                <div class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1 text-truncate">
                    <ngb-highlight
                        [result]="metaDataItem.value"
                        [title]="metaDataItem.value"
                        class="font-weight-bold truncate truncate-lg"
                        [term]="searchTerm">
                    </ngb-highlight>
                  </div>
                </div>
              </td>
              <td>
                <ngb-highlight
                    [result]="metaDataItem.updateBy"
                    [title]="metaDataItem.updateBy"
                    class="font-weight-bold truncate truncate-lg"
                    [term]="searchTerm">
                </ngb-highlight>
              </td>

              <td [innerText]="formatTime(metaDataItem.updateTime)"></td>
              <td class="text-right">
                <scitis-admin-metadata-action
                    [metadata]="metaDataItem"
                    [parent]="parent()"
                    [type]="type()"
                    [userIsAllowedToEdit]="userIsAllowedToEdit"
                    (metadataDeleteEvent)="onDeleteMetadataSuccess($event)"
                    (metadataSaveEvent)="onMetadataSaveSuccess($event)">
                </scitis-admin-metadata-action>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (metaDataArray.length === 0) {
        <div
            class="d-flex align-items-center justify-content-center mb-0 mt-3 alert alert-info text-center">
          <em class="fa-solid fa-circle-info mr-2"></em>
          <span translate>No metadata found for searched term.</span>
        </div>
      }
    </div>

  </div>
</div>


<scitis-ngx-pagination
    [id]="paginateSettings.id"
    paginationClass="col"
    [itemsPerPage]="paginateSettings.itemsPerPage"
    [itemsPerPageOptions]="itemsPerPageOptions"
    (itemsPerPageChange)="onItemsPerPageChange($event)"
    (pageNumberChange)="onLoadPageNumber($event)">
</scitis-ngx-pagination>
